module.exports = __webpack_public_path__ + "img/05.b35c5808.png";